import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function Articles() {
  return (
    <>
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '最新资讯' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                最新资讯
              </h1>
              <p className="text-foreground-500 text-sm md:text-base">
                深夜生活指南、服务动态、用户故事——凌晨不打烊的精彩内容都在这里
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <ArticleCard
                  key={article.id}
                  id={article.id}
                  title={article.title}
                  summary={article.summary}
                  imageUrl={article.imageUrl}
                  date={article.date}
                  readTime={article.readTime}
                />
              ))}
            </div>

            {articles.length === 0 && (
              <div className="text-center py-16">
                <i className="ri-article-line text-4xl text-foreground-300 mb-3"></i>
                <p className="text-foreground-400">暂无文章</p>
              </div>
            )}
          </div>
        </section>
      </main>
    </>
  );
}